/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Have_AccountInputs */

const en_us2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have an account`)
};

const pt_br2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tenho conta`)
};

const es_419_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tengo cuenta`)
};

const pt_pt2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tenho conta`)
};

const fr_fr2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai déjà un compte`)
};

const de_de2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe ein Konto`)
};

const it_it2_auth_have_account = /** @type {(inputs: Auth_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho già un account`)
};

/**
* | output |
* | --- |
* | "I have an account" |
*
* @param {Auth_Have_AccountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_have_account = /** @type {((inputs?: Auth_Have_AccountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Have_AccountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_have_account(inputs)
	if (locale === "es-419") return es_419_auth_have_account(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_have_account(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_have_account(inputs)
	if (locale === "de-DE") return de_de2_auth_have_account(inputs)
	if (locale === "it-IT") return it_it2_auth_have_account(inputs)
	return en_us2_auth_have_account(inputs)
});
export { auth_have_account as "auth.have_account" }